// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__xRaoZ","tab":"ProcedureTabs_tab__3d7w4"};